import { queryClient } from '@hotjar/webapp/utils/react-query';
import { useCurrentUser } from '@hotjar/user';
import { useCurrentSite } from '@hotjar/site';
import type { UseQueryResult } from 'react-query';
import { useQuery } from 'react-query';
import { getUserPersonalizationInfo } from './api';
import type { UserPersonalizationInfo } from './types';

const USER_PERSONALIZATION_QUERY_KEY = 'user_personalization';
const USER_PERSONALIZATION_STALE_TIME = 10000;

export const invalidateUserPersonalizationInfoQuery = (): void => {
  queryClient.invalidateQueries([USER_PERSONALIZATION_QUERY_KEY]);
};

export const useUserPersonalizationInfoQuery = (): UseQueryResult<
  UserPersonalizationInfo,
  Error
> => {
  const { data: currentUser } = useCurrentUser();
  const { data: currentSite } = useCurrentSite();
  const enabled = currentSite?.id !== undefined && currentUser?.id !== undefined;

  return useQuery({
    queryKey: [
      USER_PERSONALIZATION_QUERY_KEY,
      { siteId: currentSite?.id, userId: currentUser?.id },
    ],
    queryFn: () => {
      if (!enabled) throw new Error();
      return getUserPersonalizationInfo(currentSite?.id, currentUser?.id);
    },
    enabled,
    staleTime: USER_PERSONALIZATION_STALE_TIME,
    refetchOnWindowFocus: false,
  });
};
